var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaltReservoirSwitchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M38.46,14.99v40.2a5.375,5.375,0,0,1-5.22,5.51H11.18a5.375,5.375,0,0,1-5.22-5.51V14.99",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M33.24,62H11.18a6.679,6.679,0,0,1-6.53-6.81V14.99H7.26v40.2a4.078,4.078,0,0,0,3.91,4.21H33.23a4.071,4.071,0,0,0,3.91-4.21V14.99h2.61v40.2A6.65,6.65,0,0,1,33.24,62Z",
    fill: "#00c7b3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M29.59,27.68a3.2,3.2,0,0,1,.95,1.98l1.83,18.96a3.483,3.483,0,0,1-.9,2.67,3.914,3.914,0,0,1-2.9,1.26l-13.02.07a3.541,3.541,0,0,1-2.64-1.12,3.128,3.128,0,0,1-.85-2.42l1.66-19.33a3.393,3.393,0,0,1,3.46-3.02l9.88-.05A3.542,3.542,0,0,1,29.59,27.68Z",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M27.53,24.19l.02,4-10.89.06-.02-4Z",
    fill: "#00c7b3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M16.36,47.21l.29-20.49,10.89-.06.24,20.57A1.767,1.767,0,0,1,26.01,49H18.13A1.753,1.753,0,0,1,16.36,47.21Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M14.13,24.05a1.773,1.773,0,0,0,1.75,1.72L28.3,25.7a1.767,1.767,0,0,0,1.73-1.83,4.686,4.686,0,0,0-1.41-3.32,4.764,4.764,0,0,0-3.36-1.37l-6.42.03a4.722,4.722,0,0,0-3.35,1.4A4.777,4.777,0,0,0,14.13,24.05Zm11.93-3.56c.88.86-.47,2.22-1.35,1.35S25.18,19.62,26.06,20.49Zm-3.31.01c.88.86-.47,2.22-1.35,1.35S21.87,19.64,22.75,20.5Zm-3.32.02c.88.86-.47,2.22-1.35,1.35S18.56,19.66,19.43,20.52Z",
    fill: "#00c7b3"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M13.46,11.26V5.51A5.2,5.2,0,0,1,18.68.32h7.07a5.2,5.2,0,0,1,5.22,5.19v5.75",
    fill: "#00c7b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M31.29,11.26h-.65V5.51A4.878,4.878,0,0,0,25.75.65H18.68a4.878,4.878,0,0,0-4.89,4.86v5.75h-.65V5.51A5.535,5.535,0,0,1,18.69,0h7.07a5.535,5.535,0,0,1,5.55,5.51v5.75Z",
    fill: "#404041"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M49,15.42H3.22A2.881,2.881,0,0,1,.33,12.55V11.04A2.874,2.874,0,0,1,3.22,8.17H49",
    fill: "#00c7b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M49,15.75H3.22A3.214,3.214,0,0,1,0,12.55V11.04a3.214,3.214,0,0,1,3.22-3.2H49v.65H3.22A2.556,2.556,0,0,0,.66,11.04v1.51A2.563,2.563,0,0,0,3.22,15.1H49Z",
    fill: "#404041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaltReservoirSwitchOn);
export default __webpack_public_path__ + "static/media/salt_reservoir_switch_on.3c5d60c8b02e94f38a2123c35949ebe0.svg";
export { ForwardRef as ReactComponent };